import ProfilePhotoProps from './type';
import defaultPhoto from '../assets/images/profile.svg';
import { ProfilePhotoImgStyled, ProfilePhotoWrapperStyled } from './styled';

const ProfilePhoto = ({ ...props }: ProfilePhotoProps) => {
  const { src: photoDriver, size } = props;

  return (
    <ProfilePhotoWrapperStyled {...props}>
      <ProfilePhotoImgStyled
        size={size}
        src={photoDriver || defaultPhoto}
        alt={photoDriver ? 'profilePhoto' : 'defaultProfilePhoto'}
      />
    </ProfilePhotoWrapperStyled>
  );
};

ProfilePhoto.defaultProps = {
  size: 60,
};

export default ProfilePhoto;
